//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import conn from "../SmartLink/components/Conn/index";
import senior from "../SmartLink/components/Senior/index";
import modeDialog from "../SmartLink/components/Mode/contDialog";
export default {
  name: "smartNms",
  props: ["loading", "data", "noSname", "deviceDid", "deviceSn", "vendorName", "originalServer", "linkOptions", "deviceSoftwareVer"],
  data: function data() {
    return {
      activeName: "default"
    };
  },
  components: {
    conn: conn,
    senior: senior,
    modeDialog: modeDialog
  },
  methods: {
    updateData: function updateData() {
      this.$emit("GetConfig", {
        name: "网管服务"
      });
    },
    modeEdit: function modeEdit(row, index) {
      this.$refs.modeDialog.show(row, index);
    }
  }
};